import React from 'react';
import { CustomArrowProps } from 'react-slick';

type IArrowProps = CustomArrowProps & {
  direction: 'left' | 'right';
  color: string;
};

const Arrow = ({ direction, color = 'white', style, onClick }: IArrowProps) => {
  return (
    <button
      className={`slider-control slider-control-prev slick-arrow arrow-${direction}`}
      style={style}
      onClick={onClick}
    >
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
          <path
            d="M1.71 250c0 137.834 111.266 249.756 248.29 249.756S498.29 387.833 498.29 250 387.025.242 250 .242C112.975.243 1.71 112.166 1.71 250zm17.27 0C18.98 121.555 122.308 17.616 250 17.616c127.692 0 231.022 103.939 231.022 232.384 0 128.446-103.33 232.385-231.022 232.385-127.691 0-231.02-103.94-231.02-232.385zm310.333-114.587c-33.263 27.823-66.096 55.305-98.907 82.744-10.574 8.835-21.006 17.783-31.621 26.532-2.115 1.716-1.847 2.638 0 4.255 12.11 10.82 24.149 21.724 36.216 32.615q18.37 16.527 36.76 33.04 26.376 23.74 52.738 47.506c.867.78 1.804 1.468 2.862 2.333a156.326 157.249 0 0 1-13.66 7.686c-1.911 1-3.152.709-4.632-.646-7.662-6.97-15.373-13.883-23.07-20.803q-25.721-23.135-51.456-46.271-24.79-22.327-49.56-44.67c-4.37-3.941-8.697-7.926-13.152-11.77-1.621-1.417-1.41-2.197.12-3.466q34.299-28.567 68.527-57.212 32.347-27.05 64.672-54.127c.902-.752 1.833-1.468 2.742-2.22 5.526-4.53 5.54-4.56 11.645-1.177 3.143 1.716 6.252 3.595 9.776 5.65z"
            fill={color}
          ></path>
        </svg>
      </span>
      Slider arrow
    </button>
  );
};

export default Arrow;
